export default __webpack_public_path__ + "static/media/unicons.ca6ba135.eot";